import React from 'react';

import {
  AnalyticsApiResponse,
  Column,
  Dimension,
  QueryVariables,
  TopLevelFilter
} from 'client/Reports/reports.types';
import {columnIsAvailable} from 'client/Reports/reports.utils';

import Cell from './Cell';

import './reports-table.scss';

interface Props {
  columns: Column[];
  dimensions: Dimension[];
  variables: QueryVariables;
  data: any[];
  topLevelFilterType: TopLevelFilter;
}

const BodyRenderer = ({columns, data, dimensions, variables, topLevelFilterType}: Props) => {
  return (
    <tbody>
      {data.map((row: AnalyticsApiResponse) => {
        if (!row) {
          return null;
        }

        const {id} = row.dimensions[0].value;

        return (
          <tr key={id}>
            {columns
              .filter((c) => columnIsAvailable(c, dimensions, variables, topLevelFilterType))
              .map((column) => (
                <Cell
                  key={`${column.key}-${id}`}
                  data={row}
                  dataRenderer={(datum) => {
                    if (column.columnType === 'dimension') {
                      return column.renderColumn(datum.dimensions, dimensions);
                    }
                    return column.renderColumn(datum, dimensions, variables);
                  }}
                  defaultSort={!!column.primaryColumn}
                  className='reports-table__cell'
                />
              ))}
          </tr>
        );
      })}
    </tbody>
  );
};

export default BodyRenderer;
